var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 531,
    viewBox: "0 0 496 531",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71213 8.49244C1.71213 4.62645 4.84614 1.49243 8.71213 1.49243H415.705C459.335 1.49243 494.705 36.8619 494.705 80.4924V523C494.705 526.866 491.571 530 487.705 530H80.7122C37.0817 530 1.71213 494.63 1.71213 451V8.49244Z",
    stroke: "#FFCD03",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgBorder);
export default __webpack_public_path__ + "static/media/img-bg-border.7ea6a741409b8c2969721925e7286000.svg";
export { ForwardRef as ReactComponent };